import { graphql } from '../generated';

export const START_TEST_POD = graphql(`
  mutation StartTestPod {
    startTestPod {
      run {
        ...TestPodFields
      }
      userErrors {
        code
        message
      }
    }
  }
`);
